import {
  IDataAttributeMap,
  mapWithDataPrefix,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  TooltipPosition,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../../common/contexts/index';
import { Color } from '../../../common/types/color';
import { IDiscountBadge } from '../DiscountBadge.interfaces';
import { DiscountBadgeTooltip } from './../DiscountBadgeTooltip';
import {
  DiscountBadgeContainer,
  TextWrapper,
  TooltipContainer,
} from './discountBadgeUrgent.styles';

/**
 * Represents the urgent discount badge
 */
const DiscountBadgeUrgent: React.FunctionComponent<Partial<IDiscountBadge>> = props => {
  const { showTooltip, discountPrice, discountTooltip, dataAttributes } = props;
  const discountPriceWithStyle: string = `<span class='discount-price'>${discountPrice}</span>`;

  const dataAttr: IDataAttributeMap = mapWithDataPrefix(dataAttributes);

  return (
    <TranslationsContext.Consumer>
      {({ translations }) => (
        <DiscountBadgeContainer {...dataAttr}>
          <TextWrapper showTooltip={showTooltip}>
            <ResponsiveTypography
              variant={ResponsiveTypographyVariant.body}
              lineHeight={'1'}
              component="div"
            >
              <React.Fragment>
                <ResponsiveTypography
                  variant={ResponsiveTypographyVariant.microBold}
                  component="span"
                  allowDangerousRender={true}
                  color={Color.red}
                  lineHeight={'1'}
                >
                  {i18n('discountBadge.urgent', [discountPriceWithStyle], translations)}
                </ResponsiveTypography>
                {showTooltip && (
                  <TooltipContainer>
                    <DiscountBadgeTooltip
                      position={TooltipPosition.bottomRight}
                      discountTooltip={discountTooltip}
                    />
                  </TooltipContainer>
                )}
              </React.Fragment>
            </ResponsiveTypography>
          </TextWrapper>
        </DiscountBadgeContainer>
      )}
    </TranslationsContext.Consumer>
  );
};

export default DiscountBadgeUrgent;
